import React from 'react';

export const AnglesLeft = ({
  className,
  color = '#14142B',
  height = '24px',
  width = '24px',
}: {
  className?: string;
  color?: string;
  height?: string
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.1555 16.6555L12.5 12L17.1555 7.34448"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 16.6555L6.8445 12L11.5 7.34448"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
